/**
 * App theme - no theme switching; app always uses light styling.
 */

export type AppTheme = 'light';

/**
 * Apply theme to app root element (always light).
 */
export function applyAppTheme(): void {
  document.documentElement.setAttribute('data-theme', 'light');
}
